import { listCartItems } from "@/graphql/queries";
import { Cart } from "@/types/AppTypes";
import { createQueryOptions } from "../shared/createQueryOptions";
import { parseJSONField } from "@/utils/helper/parseJSON";

export const fetchAllCartItemsQueryOptions = (
  filters: Record<string, any> = {},
  options = {},
  limit?: number
) =>
  createQueryOptions<Cart>({
    queryKey: ["all_cart_items", filters],
    graphqlQuery: listCartItems,
    getVariables: () => ({
      limit,
      filter: {
        ...filters,
      },
    }),
    options: {
      select: (data: Cart[]) => {
        return data.map((item) => {
          return {
            ...item,
            variant: item?.variant ? parseJSONField(item?.variant) : null,
          };
        });
      },
      enabled: false, 
      ...options,
    },
  });
